"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[366],{

/***/ 2025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ api_pokeApi; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/axios@1.1.3/node_modules/axios/index.js + 40 modules
var axios = __webpack_require__(3885);
;// CONCATENATED MODULE: ./api/pokeApi.ts

var pokeApi = axios/* default.create */.ZP.create({
    baseURL: "https://pokeapi.co/api/v2"
});
/* harmony default export */ var api_pokeApi = (pokeApi);

;// CONCATENATED MODULE: ./api/index.ts



/***/ }),

/***/ 2354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/head.js
var head = __webpack_require__(1161);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ui/index.ts + 2 modules
var ui = __webpack_require__(3079);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/container/index.js + 2 modules
var container = __webpack_require__(4280);
;// CONCATENATED MODULE: ./components/layouts/Layout.tsx





var Layout = function(param) {
    var children = param.children, _title = param.title, title = _title === void 0 ? "Pok\xe9mon App" : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(title.charAt(0).toUpperCase()).concat(title.substring(1))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "Josu\xe9 Almonasi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Info about Pok\xe9mon ".concat(title)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "".concat(title, ", pok\xe9mon, pokemon, pokedex")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* NavBar */.l, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                as: "main",
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/layouts/index.ts



/***/ }),

/***/ 8382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u6": function() { return /* reexport */ FavPokemonCard; },
  "vz": function() { return /* reexport */ FavPokemonGrid; },
  "cM": function() { return /* reexport */ PokemonCard; },
  "AY": function() { return /* reexport */ PokemonDetail; },
  "Cw": function() { return /* reexport */ PokemonGrid; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/grid/index.js + 4 modules
var grid = __webpack_require__(2494);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/card/index.js + 6 modules
var card = __webpack_require__(3321);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/row/index.js + 2 modules
var row = __webpack_require__(5551);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/text/index.js + 3 modules
var esm_text = __webpack_require__(3638);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/router.js
var next_router = __webpack_require__(1463);
;// CONCATENATED MODULE: ./components/pokemon/Pokemoncard.tsx



var PokemonCard = function(param) {
    var pokemon = param.pokemon;
    var router = (0,next_router.useRouter)();
    var handleOnclick = function() {
        router.push("/pokemon/".concat(pokemon.name));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
        xs: 6,
        sm: 3,
        xl: 1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
            isHoverable: true,
            isPressable: true,
            onClick: handleOnclick,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default.Body */.ZP.Body, {
                css: {
                    p: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Image */.ZP.Image, {
                        loading: "lazy",
                        src: pokemon.image,
                        width: "100%",
                        height: 140
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Footer */.ZP.Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                            justify: "space-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                transform: "capitalize",
                                children: pokemon.name
                            })
                        })
                    })
                ]
            })
        })
    }, pokemon.id);
};

;// CONCATENATED MODULE: ./components/pokemon/PokemonGrid.tsx



var PokemonGrid = function(param) {
    var pokemonList = param.pokemonList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
        gap: 2,
        justify: "flex-start",
        children: pokemonList.map(function(pokemon) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PokemonCard, {
                pokemon: pokemon
            }, pokemon.id);
        })
    });
};

;// CONCATENATED MODULE: ./components/pokemon/FavPokemonGrid.tsx



var FavPokemonGrid = function(param) {
    var favs = param.favs;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
        gap: 2,
        justify: "flex-start",
        children: favs.length !== 0 && favs.map(function(id) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FavPokemonCard, {
                id: id
            }, id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/col/index.js + 2 modules
var col = __webpack_require__(7743);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/badge/index.js + 3 modules
var badge = __webpack_require__(1648);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/button/index.js + 8 modules
var esm_button = __webpack_require__(5809);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/container/index.js + 2 modules
var container = __webpack_require__(4280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/image/index.js + 9 modules
var esm_image = __webpack_require__(4181);
;// CONCATENATED MODULE: ./components/pokemon/PokemonDetail.tsx


var PokemonDetail = function(param) {
    var pokemon = param.pokemon, isFav = param.isFav, onToggleFav = param.onToggleFav;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.ZP.Container, {
        gap: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                xs: 12,
                sm: 5,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.ZP, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Image */.ZP.Image, {
                                src: ((ref = pokemon.sprites.other) === null || ref === void 0 ? void 0 : ref.dream_world.front_default) || "/images/not-found.png",
                                alt: pokemon.name,
                                loading: "lazy",
                                width: 300,
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Footer */.ZP.Footer, {
                            isBlurred: true,
                            css: {
                                bgBlur: "#9d6df646",
                                bottom: 0,
                                zIndex: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                children: "Abilities:"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                            css: {
                                                padding: 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
                                                gap: 1,
                                                children: pokemon.abilities.map(function(a) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.ZP, {
                                                            disableOutline: true,
                                                            color: "primary",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                                transform: "capitalize",
                                                                color: "withe",
                                                                children: a.ability.name
                                                            })
                                                        })
                                                    }, a.slot);
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                xs: 12,
                sm: 7,
                md: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default */.ZP, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Header */.ZP.Header, {
                            css: {
                                p: 24
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                align: "center",
                                justify: "space-between",
                                wrap: "wrap",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                        h1: true,
                                        transform: "capitalize",
                                        children: pokemon.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                                        auto: true,
                                        color: "gradient",
                                        ghost: !isFav,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                            css: {
                                                color: "inherit"
                                            },
                                            size: 12,
                                            weight: "bold",
                                            transform: "uppercase",
                                            onClick: onToggleFav,
                                            children: "".concat(isFav ? "Remove from" : "Add to", " favorites")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(card/* default.Body */.ZP.Body, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                    size: 30,
                                    children: "Sprites:"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
                                    direction: "row",
                                    display: "flex",
                                    gap: 0,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.ZP, {
                                            src: pokemon.sprites.front_default,
                                            alt: pokemon.name,
                                            width: 100,
                                            height: 100
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.ZP, {
                                            src: pokemon.sprites.back_default,
                                            alt: pokemon.name,
                                            width: 100,
                                            height: 100
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.ZP, {
                                            src: pokemon.sprites.front_shiny,
                                            alt: pokemon.name,
                                            width: 100,
                                            height: 100
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.ZP, {
                                            src: pokemon.sprites.back_shiny,
                                            alt: pokemon.name,
                                            width: 100,
                                            height: 100
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7135);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(4254);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
// EXTERNAL MODULE: ./api/index.ts + 1 modules
var api = __webpack_require__(2025);
;// CONCATENATED MODULE: ./components/pokemon/FavPokemonCard.tsx







var FavPokemonCard = function(param) {
    var id = param.id;
    var router = (0,next_router.useRouter)();
    var handleOnclick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, name;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            api/* pokeApi.get */.T.get("/pokemon/".concat(id))
                        ];
                    case 1:
                        data = _state.sent().data;
                        name = data.name;
                        router.push("/pokemon/".concat(name));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOnclick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
        xs: 6,
        sm: 3,
        xl: 1,
        onClick: handleOnclick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
            isHoverable: true,
            isPressable: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                css: {
                    p: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Image */.ZP.Image, {
                    loading: "lazy",
                    src: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/".concat(id, ".svg"),
                    width: "100%",
                    height: 140
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/pokemon/index.ts







/***/ }),

/***/ 3079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* reexport */ NavBar; },
  "O": function() { return /* reexport */ NoFavs; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(1527);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/navbar/index.js + 34 modules
var navbar = __webpack_require__(2619);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/spacer/index.js + 2 modules
var spacer = __webpack_require__(1340);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/image.js
var next_image = __webpack_require__(2829);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_biqbaboplfbrettd7655fr4n2y/node_modules/next/link.js
var next_link = __webpack_require__(143);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/ui/NavBar.tsx




var NavBar = function() {
    var collapseItems = [
        {
            name: "Favorites",
            path: "favorites"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(navbar/* default */.ZP, {
        isBordered: true,
        variant: "sticky",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(navbar/* default.Brand */.ZP.Brand, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(navbar/* default.Content */.ZP.Content, {
                        showIn: "xs",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default.Toggle */.ZP.Toggle, {
                                "aria-label": "toggle navigation"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                                y: 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default.Content */.ZP.Content, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/assets/img/pokemon-logo.png",
                                        alt: "Pokemon",
                                        height: 76,
                                        width: 80
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default.Content */.ZP.Content, {
                hideIn: "xs",
                variant: "underline",
                children: collapseItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(item.path),
                            children: item.name
                        })
                    }, item.name);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default.Collapse */.ZP.Collapse, {
                children: collapseItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar/* default.CollapseItem */.ZP.CollapseItem, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/".concat(item.path),
                            color: "inherit",
                            children: item.name
                        })
                    }, item.name);
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/container/index.js + 2 modules
var container = __webpack_require__(4280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/text/index.js + 3 modules
var esm_text = __webpack_require__(3638);
// EXTERNAL MODULE: ./node_modules/.pnpm/@nextui-org+react@1.0.0-beta.10_biqbaboplfbrettd7655fr4n2y/node_modules/@nextui-org/react/esm/image/index.js + 9 modules
var esm_image = __webpack_require__(4181);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(959);
;// CONCATENATED MODULE: ./components/ui/NoFavs.tsx



var NoFavs = function(param) {
    var _showIn = param.showIn, showIn = _showIn === void 0 ? true : _showIn;
    return showIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        css: {
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 100px)",
            alignItems: "center",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h1: true,
                children: "No favs yet"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_image/* default */.ZP, {
                src: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/dream-world/132.svg",
                width: 250,
                height: 250,
                alt: "Ditto",
                css: {
                    opacity: 0.5
                }
            })
        ]
    }) : null;
};

;// CONCATENATED MODULE: ./components/ui/index.ts




/***/ }),

/***/ 139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zp": function() { return /* reexport */ favPokemons; },
  "n1": function() { return /* reexport */ isFav; },
  "w6": function() { return /* reexport */ toggleFav; }
});

// UNUSED EXPORTS: getPokemonInfo

;// CONCATENATED MODULE: ./utils/Favorites.ts
var toggleFav = function(id) {
    var favorites = new Set(JSON.parse(localStorage.getItem("favorites") || "[]"));
    favorites.has(id) ? favorites.delete(id) : favorites.add(id);
    localStorage.setItem("favorites", "[".concat(Array.from(favorites), "]"));
};
var isFav = function(id) {
    /* Checks if running in a web window */ if (false) {}
    return JSON.parse(localStorage.getItem("favorites") || "[]").includes(id);
};
var favPokemons = function() {
    return JSON.parse(localStorage.getItem("favorites") || "[]");
};


// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7135);
// EXTERNAL MODULE: ./node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(4254);
// EXTERNAL MODULE: ./api/index.ts + 1 modules
var api = __webpack_require__(2025);
;// CONCATENATED MODULE: ./utils/getPokemonInfo.ts



var getPokemonInfo = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(nameOrId) {
        var data, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        api/* pokeApi.get */.T.get("/pokemon/".concat(nameOrId.toLocaleLowerCase()))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            id: data.id,
                            name: data.name,
                            sprites: data.sprites,
                            abilities: data.abilities
                        }
                    ];
                case 2:
                    error = _state.sent();
                    return [
                        2,
                        null
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPokemonInfo(nameOrId) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./utils/index.ts




/***/ })

}]);